import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { CongratulationsEmojiIcon, GreatJobIcon } from "../../../utils/icons";
import {
  StyledModal,
  InitiativesContainer,
} from "../../ContentV2/SideBarContiner/Styles";
import { t } from "i18next";
import { ImageUrl } from "../../../utils/constants";

import {
  HeaderWrapper,
  HeaderText,
  StyledBorder,
  CenterText,
  InitiativeName,
  InitiativeIcon,
  CongratsWrapper,
  CongratsTitle,
  CongratsSubText,
} from "./styles";
import { CommonButtonPopup } from "../../ReportsV2/styles";
import { Border } from "../../RecogntionAdmin/styles";

const InitiativeCompleteModal = ({
  isConfirmDetails,
  initiativeData,
  hideIsConfirmDetails,
}) => {
  useEffect(()=>{},[])
  return (
    <StyledModal show={isConfirmDetails} width="400px" height="380">
      <HeaderWrapper>
        {GreatJobIcon()}
        <HeaderText>{t("Great job")}</HeaderText>
      </HeaderWrapper>

      <StyledBorder />

      <Modal.Body>
        <InitiativesContainer>
          <CenterText>
            You completed your
            <InitiativeName>{initiativeData?.name}</InitiativeName>
          </CenterText>

          <InitiativeIcon background={initiativeData?.color}>
            <div className='icon'>
              <img
                className='initiative-image'
                src={`${ImageUrl}/${initiativeData?.initiative_white_icon}`}
                alt={initiativeData?.name || "initiative"}
                onError={(e) => { e.currentTarget.src = `${ImageUrl}/default-initiative.png`; }}
              />
            </div>
          </InitiativeIcon>

          <CongratsWrapper>
            <CongratsTitle>
              <span style={{ marginRight: "5px" }}>Congratulations!</span>
              {CongratulationsEmojiIcon()}
            </CongratsTitle>

            <CongratsSubText>
              {initiativeData?.points === 0
                ? "You have done a great job"
                : `You earned +${initiativeData?.points} Points`}
            </CongratsSubText>
            <Border style={{margin:'20px 0px'}}/>
          </CongratsWrapper>

          <CommonButtonPopup onClick={hideIsConfirmDetails} width={'100%'}>
            Thank You!
          </CommonButtonPopup>
        </InitiativesContainer>
      </Modal.Body>
    </StyledModal>
  );
};

InitiativeCompleteModal.propTypes = {
  isConfirmDetails: PropTypes.bool.isRequired,
  initiativeData: PropTypes.object.isRequired,
  hideIsConfirmDetails: PropTypes.func.isRequired,
};

export default InitiativeCompleteModal;
